import { CountryEnum } from "enums/country.enum";

export function setName(name: string, lastName: string, pais_id: number): string {
    return pais_id == CountryEnum.Brasil ? name + ((!!lastName) ? ' ' + lastName : "") : ((!!lastName && lastName != "") ? lastName + ', ' : "") + name
}
